import React from "react";
import styles from "./inputComponent.module.scss";
import EyeOff from "../../assets/images/login/eyeoff.png";
import EyeOn from "../../assets/images/login/oneye.png";
import { useAppSelector } from "../../hooks/hook";
import { RootState } from "../../redux/store";
interface InputComponentProps {
  label?: string;
  type: string;
  name: string;
  placeholder?: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  isPassword?: boolean;
  isShowPassword?: boolean;
  toggleShowPassword?: () => void;
  error?: string;
  maxLength?: number;
  autoComplete?: boolean;
}

const InputComponent: React.FC<InputComponentProps> = ({
  label,
  type,
  name,
  placeholder,
  maxLength,
  value,
  onChange,
  isPassword = false,
  isShowPassword = false,
  toggleShowPassword,
  error,
  autoComplete,
}) => {
  return (
    <div className={styles.input_container}>
      {label && <p className={styles.inputText}>{label}</p>}
      <div className={styles.input_control}>
        <input
          style={{color:'#000'}}
          type={isPassword && isShowPassword ? "text" : type}
          name={name}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          maxLength={maxLength}
          autoComplete={autoComplete ? "new-password" : ""}
        />
        {isPassword && toggleShowPassword && (
          <div onClick={toggleShowPassword} className={styles.passwordIcon}>
            <img src={isShowPassword ? EyeOff : EyeOn} alt="EyeIcon" />
          </div>
        )}
      </div>
      {error ? (
        <p
          className={`${styles.errorMessage} ${
            error ? styles.visible : styles.hidden
          }`}
        >
          {error}
        </p>
      ) : (
        <p className={styles.hidden}>empty</p>
      )}
    </div>
  );
};

export default InputComponent;
